<template>
  <div v-if="loadComponent">
    <v-container>
      <h1>{{ title }}</h1>
      <v-tabs vertical>
        <v-tab class="text-none">Modem</v-tab>
        <v-tab class="text-none">API</v-tab>
        <v-tab class="text-none">Globe API</v-tab>

        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <!-- <router-view /> -->
              <modem></modem>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <!-- <router-view /> -->
              <busybee></busybee>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <!-- <router-view /> -->
              <globe></globe>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs>
    </v-container>
  </div>
</template>
<script>
// import { mapState, mapActions } from "vuex";
// import isEmpty from "lodash/isEmpty";
import userAccessMixin from "../../../../mixins/userAccessMixin";
import Modem from "./Modem";
import Globe from "./Globe";
import Busybee from "./Busybee";
//const API_ENDPOINT = "/api/config";
export default {
  mixins: [userAccessMixin],
  metaInfo: {
    title: "SMS Configuration",
    titleTemplate: `%s - ${process.env.VUE_APP_NAME}`
  },
  data: () => ({
    title: "SMS Config"
  }),
  components: {
    Modem,
    Globe,
    Busybee
  },
  created() {
    // this.getEmailConfig();

    this.getUserAccessRights("SMSConfig");
  }
};
</script>
